// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"201":"component---src-gatsby-entities-page-tsx","336":"component---node-modules-shapeable-gatsby-theme-shapeable-web-src-components-404-tsx"}[chunkId] + "-" + {"201":"220b64849d460bd2a3b8","336":"dc7c7f4a787ab0754d31"}[chunkId] + ".js";
};